const maintenance = {
  on: "iizenglish wird derzeit gewartet und ist in wenigen Minuten wieder verfügbar.",
  details: "Bitte aktualisieren Sie die Seite in Kürze.",
  futureUpdateBannerMsg:
    "iizenglish wird am {date} aktualisiert und ist für einige Minuten nicht verfügbar.",
};

export default maintenance;
